import React from 'react';
import {useField} from 'react-final-form';
import Input from 'common/componentsV2/Input';

const additionalProps = {
  autocomplete: 'off',
};

const Password = () => {
  const {
    input: {value, onChange},
    meta,
  } = useField('password');
  return (
    <Input
      additionalProps={additionalProps}
      type="password"
      placeHolder="Password"
      automationId="password"
      isInvalid={meta.touched && meta.error}
      invalidMessage={meta.error}
      value={value}
      onChange={onChange}
    />
  );
};

export default Password;
